// extracted by mini-css-extract-plugin
export default {"canvasCcontainer":"previewComponent_canvasCcontainer__cMN+Y","canvasPreview":"previewComponent_canvasPreview__gx2vI"};